import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { typography } from 'src/config/typography';
import { below, media, widthBreakpoints } from 'src/config/breakpoints';
import { IconProps } from 'src/lib/IconBox';
import { useMediaQuery } from 'src/common/migration/useMediaQuery';
import { StyleProps } from 'src/lib/styleProps';

const Info = styled.div`
  font-family: ${typography.fontFamilyHeaders};
  font-size: 0.625rem;
  margin-bottom: 2.5rem;
  padding: 0 1.375rem;

  ${media.w.min.px768(css`
    margin-bottom: 1.75rem;
    padding-left: 0;
    padding-right: 1.5625rem;
  `)};
`;

const InfoValue = styled.div`
  align-items: center;
  display: flex;
  font-size: 1rem;
  line-height: 1.375rem;
  margin-bottom: 0.3125rem;

  ${media.w.min.px768(css`
    font-size: 1.5rem;
    line-height: 1.875rem;
    margin-bottom: 0;
  `)};

  svg {
    margin-right: 0.9375rem;

    ${media.w.min.px768(css`
      margin-right: 0.5625rem;
    `)};
  }
`;

const StyledIcon = styled.svg``;

export interface InfoRateProps {
  icon: FC<IconProps>;
  rate: string;
  text?: string;
}

export const InfoRate: FC<InfoRateProps & StyleProps> = ({ className, icon, rate, text }) => {
  const isMobile = useMediaQuery({ maxWidth: below(widthBreakpoints.px768) });

  return (
    <Info className={className}>
      <InfoValue>
        <StyledIcon as={icon} size={isMobile ? 20 : 23} />
        {rate}
      </InfoValue>
      {text}
    </Info>
  );
};
